import { createAction } from 'redux-actions';
import firebase from 'firebase';
import mixpanel from 'mixpanel-browser';

// Constants
export const AUTH_SUCCESS = 'auth/AUTH_SUCCESS';
export const AUTH_REQUEST = 'auth/AUTH_REQUEST';
export const AUTH_USER_CHANGED = 'auth/AUTH_USER_CHANGED';

// Reducer
const initialState = {
  uid: null,
  email: null,
  favoriteCharts: {},
  favoriteInfographics: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case AUTH_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case AUTH_USER_CHANGED: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

// Action creators
export const authSuccess = createAction(AUTH_SUCCESS);
export const authRequest = createAction(AUTH_REQUEST);
export const authUserChanged = createAction(AUTH_USER_CHANGED);

export const listenToFirebaseUser = uid => dispatch => {
  firebase
    .database()
    .ref('users')
    .child(uid)
    .on('value', snap => {
      if (snap.exists()) {
        const user = snap.val();
        window.Intercom('update', {
          favoriteCharts: Object.keys(user.favoriteCharts || {}).length,
          favoriteInfographics: Object.keys(user.favoriteInfographics || {})
            .length,
          nCharts: Object.keys(user.charts || {}).length,
          nInfographics: Object.keys(user.infographics || {}).length,
          email: user.email,
        });
        mixpanel.people.set({
          favoriteCharts: Object.keys(user.favoriteCharts || {}).length,
          favoriteInfographics: Object.keys(user.favoriteInfographics || {})
            .length,
          nCharts: Object.keys(user.charts || {}).length,
          nInfographics: Object.keys(user.infographics || {}).length,
          email: user.email,
          name: user.email,
        });
        dispatch(
          authUserChanged({
            ...user,
            uid: snap.key,
          })
        );
      }
    });
};

export const changeAsset = asset => async (dispatch, getState) => {
  await firebase
    .database()
    .ref('users')
    .child(getState().auth.uid)
    .child('asset')
    .set(asset);
};

export const actions = {
  authSuccess,
};



// WEBPACK FOOTER //
// ./src/modules/auth/Auth.js